/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

const copyViaExecCommand = (text: string): void => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
};

/**
 * Copies the given text to the clipboard, falling back to a hidden textarea on browsers
 * without clipboard api access.
 * @param text - Text to put into the clipboard.
 * @param onCopied - Called once the text has been copied.
 */
export const copyToClipboard = (text: string, onCopied: () => void): void => {
    if (!text) {
        return;
    }

    if (navigator.clipboard) {
        navigator.clipboard
            .writeText(text)
            .then(onCopied)
            .catch(() => {
                copyViaExecCommand(text);
                onCopied();
            });
        return;
    }

    copyViaExecCommand(text);
    onCopied();
};
